/**
 * checkoutPayment
 *
 *  Form using query.mask plugin
 *
 * Description
 */
import * as formValidate from "@sharedJS/formValidate";
import * as popupOverlay from "@sharedJS/popUpOverlay";
import * as loader from "@shopJS/loader";
import * as loginReauthentication from "@JS/shop/10-login-component/loginReauthentication";
import { adyen } from "@JS/shop/ocmSettings";
import * as renderTemplate from "@sharedJS/renderTemplate";
import pushDataLayer from "@ocm/services/dataLayer.js";
import { getFavoriteBrandsToggleDimension } from "@ocm/services/services.favoriteBrandsToggleTracking";

// DOM
let $paymentOption;
let $paymentOptionCheckbox;
let $debitForm;
let $debitRemove;
let preview;
let $paymentInfo;
let $iban;
let $creditCardForm;
let $creditCardDataForm;
let $creditCardRedirectForm;
let $checkout;
let $checkoutPopup;
let $challengePopup;
let $sepaPopup;
let riskCheckFailedModal;

// DOM Selectors
let debitData;

let isClicked;
let isRendered;
// Status
let ajaxPaymentAllowedWaiting;

let $recurringDetailsContainer;

const _currentContextPath = currentContextPath || ""; // master.tag
const _checkoutPath = `${_currentContextPath}/checkout/`;

function init() {
	$checkoutPopup = $("#js-payment-error-messages");
	$sepaPopup = $("#js-sepa-error-messages");
	$challengePopup = $("#adyen-challenge");
	riskCheckFailedModal = document.querySelector("#js-payment-riskcheck-failed");

	isClicked = false;
	isRendered = false;
	ajaxPaymentAllowedWaiting = false;

	$recurringDetailsContainer = $("#recurringDetailsContainer");
	if (ocm.adyen && ocm.adyen.recurring) {
		_initcreditCardRendering();
	}
	_checkSecurityLevel(); // Klickfunktion für Zahlartenauswahl
	_debitValidation();
	_invoiceValidation();
	_debitDataRemove();
	_creditCardValidation(); // Formular neue Kreditkarte
	_creditCardDataValidation();
	_toggleSubmitButton();
	_fillInvoicePrivacyPolicyLink();
	_creditCardDataRemove();
	_pushPaymentMethodToDataLayer();
	_trackChoosePaypalPayLater();

	if (ocm.showRiskCheckFailedModal) {
		_openRiskCheckFailedModal();
	}
}

function submitForm(target, isValid) {
	if (isClicked) {
		return;
	}

	if (!isValid) {
		return;
	}

	loader.addLoader($("body"));
	loginReauthentication.precheckSessionState(); // todo: TUB-9245 login2020

	const formData = {};

	const elements = target.elements;
	const length = elements.length;

	for (let i = 0; i < length; i++) {
		const element = elements[i];
		const elementID = $(element).attr("name");
		if (elementID) {
			formData[elementID] = $(element).val();
		}
	}
	formData["screenWidth"] = screen.width;
	formData["screenHeight"] = screen.height;
	formData["colorDepth"] = screen.colorDepth;
	formData["javaEnabled"] = navigator.javaEnabled();
	formData["timeZoneOffset"] = new Date().getTimezoneOffset();
	// The language code should be the navigator.language value of the shopper's browser (as defined in IETF BCP 47): https://tools.ietf.org/html/bcp47
	formData["language"] = navigator.language;

	const url = $(target).attr("action");

	$.ajax({
		url,
		type: "POST",
		dataType: "json",
		data: formData,
	})
		.done((response) => {
			_handleResponse(response);
		})
		.fail((error) => {
			console.error("error:", error);
		})
		.always(() => {
			loader.removeLoader();
			isClicked = false;
		});

	isClicked = true;
}

function _isPaymentAllowed($element, doCallAsync) {
	const url = $element.closest("ul").attr("data-url");
	const code = $element.closest("li").attr("data-code");
	let paymentAllowed = false;
	ajaxPaymentAllowedWaiting = true;

	if (doCallAsync === "undefined") {
		doCallAsync = true;
	}

	$.ajax({
		url,
		type: "GET",
		data: { code },
		async: doCallAsync,
	})
		.done((response) => {
			loader.removeLoader();
			if (response.success === "true") {
				paymentAllowed = true;

				setTimeout(() => {
					loader.removeLoader();
				}, 100);

				if (!$element.closest($paymentOption).hasClass("is-invoice")) {
					_togglePaymentOptions($element);
				}
			} else {
				$element.find('input[type="checkbox"]').prop("disabled", true);
				loader.removeLoader();

				_openRiskCheckFailedModal();
			}
		})
		.fail(() => {
			loader.removeLoader();
		})
		.always(() => {
			ajaxPaymentAllowedWaiting = false;
		});

	// return geht hier, da der ajax-call leider async=false sein muss
	return paymentAllowed;
}

function _togglePaymentOptions($element) {
	$element.prop("checked", true);
	$paymentOptionCheckbox.not($element).prop("checked", false).closest($paymentOption).removeClass("is-active");

	if ($element.is(":checked")) {
		$element.prop("checked", true).closest($paymentOption).addClass("is-active");

		if ($element.closest($paymentOption).hasClass("is-creditCard")) {
			if (!isRendered) {
				_creditCardRendering();
				isRendered = true;
			}
		}
	} else {
		$element.prop("checked", false).closest($paymentOption).removeClass("is-active");
	}
}

function _checkSecurityLevel() {
	$paymentOption = $(".js-payment-option");
	$paymentOptionCheckbox = $paymentOption.find("input.js-checkout-payment-field__input:checkbox");

	$paymentOptionCheckbox.on("click", function () {
		const $this = $(this);

		if (
			$this.closest($paymentOption).hasClass("js-payment-secure") ||
			$this.closest($paymentOption).hasClass("is-invoice")
		) {
			_togglePaymentOptions($this);
		} else {
			_isPaymentAllowed($this);
			setTimeout(() => {
				if (ajaxPaymentAllowedWaiting === false) {
					return;
				}
				loader.addLoader($("body"));
			}, 100);
		}
	});
}

function _initcreditCardRendering() {
	const checkbox = $(".js-payment-option");
	checkbox.each(function () {
		if ($(this).attr("data-code") === "creditcard") {
			if ($(this).hasClass("is-active")) {
				_creditCardRendering();
				isRendered = true;
			}
		}
	});
}
function _creditCardRendering() {
	const recurringDetailsTemplate = $("#recurringDetailsTemplate");
	/* eslint-disable */
	const recurringdetails = { detail: ocm.adyen.recurring };
	renderTemplate.render($recurringDetailsContainer, recurringDetailsTemplate, recurringdetails);
	$.each(ocm.adyen.recurring, function () {
		const card = checkout.create("card", {
			type: this.type,
			storedDetails: this.storedDetails,
			details: this.details,
			recurringDetailReference: this.recurringDetailReference,
			onChange: _handleRecurringOnChange,
		});
		const recurringDetailReference = this.recurringDetailReference;
		card.mount(`#recurring-${recurringDetailReference}`);
	});
	/* eslint-enable */
	_creditCardDataValidation();
}

function _handleRecurringOnChange(state) {
	const recurringDetailReference = state.data.paymentMethod.storedPaymentMethodId;
	if (state.isValid && state.data.paymentMethod !== undefined) {
		$(`#cc-encryptedSecurityCode-${recurringDetailReference}`).val(state.data.paymentMethod.encryptedSecurityCode);
		$(`.js-authorise-recurring-cc[data-id=${recurringDetailReference}]`).removeAttr("disabled");
	} else {
		$(`#cc-encryptedSecurityCode-${recurringDetailReference}`).val(state.data.paymentMethod.encryptedSecurityCode);
		$(`.js-authorise-recurring-cc[data-id=${recurringDetailReference}]`).attr("disabled", "disabled");
	}
}

function _openRiskCheckFailedModal() {
	if (riskCheckFailedModal) {
		riskCheckFailedModal.classList.add("is-visible");
		riskCheckFailedModal.addEventListener("hideModal", () => {
			window.location.reload();
		});
	}
}

function _handleResponse(response) {
	if (response.type !== "undefined" && response.type === "creditcard") {
		_handleCreditCardPayment(response);
	} else if (response.type !== "undefined" && response.type === "sepa" && response.result === "nok") {
		_handleRefusedSepaAccount();
	} else {
		window.location.href = _checkoutPath;
	}
}

function _handleCreditCardPayment(response) {
	// CreditCardPayment
	switch (response.resultCode) {
		case "IdentifyShopper":
			_handleIdentifyShopper(response);
			break;
		case "ChallengeShopper":
			_handleChallengeShopper(response);
			break;
		case "RedirectShopper":
			_handleRedirectShopper(response);
			break;
		case "Refused":
		case "Error":
			_handleRefusedAdyenPayment(response.localizedRefusalReason);
			break;
		default:
			window.location.href = _checkoutPath;
	}
}

const _handleIdentifyShopper = function (response) {
	const fingerprintToken = response["threeds2.fingerprintToken"];
	if (fingerprintToken !== "undefined") {
		adyen.checkout
			.create("threeDS2DeviceFingerprint", {
				fingerprintToken,
				onComplete: _onFingerprintComplete, // Called whenever a result is available, regardless if the outcome is successful or not.
				onError() {
					console.error("Error on 3DS2Fingerprint");
				}, // Gets triggered on error.
			})
			.mount("#adyenFingerprint");
		$("#adyenFingerprint").addClass("is-active");
	}
};

function _onFingerprintComplete(fingerprintData) {
	const data = {};
	data["fingerprintResult"] = fingerprintData.data.details["threeds2.fingerprint"];
	_doAjax(data, "/checkout/multi/payment-method/validateFingerprint");
	$("#adyenFingerprint").removeClass("is-active");
}

function _handleChallengeShopper(response) {
	const challengeToken = response["threeds2.challengeToken"];
	const $threeDS2 = $("#threeDS2");

	const popUpOptions = {
		onclose: () => {
			$threeDS2.empty();
		},
	};

	popupOverlay.openPopup($challengePopup, popUpOptions);
	if (challengeToken !== "undefined") {
		adyen.checkout
			.create("threeDS2Challenge", {
				challengeToken,
				onComplete: _onChallengeComplete, // Called whenever a result is available, regardless if the outcome is successful or not.
				onError() {
					console.error("Error on 3DS2Challenge");
				}, // Gets triggered on error.
				size: "05", // Defaults to '01'
			})
			.mount("#threeDS2");
	}
}

function _onChallengeComplete(challengeData) {
	if (typeof challengeData !== "undefined") {
		const data = {};
		data["challengeResult"] = challengeData.data.details["threeds2.challengeResult"];
		_doAjax(data, "/checkout/multi/payment-method/validateChallenge");
		popupOverlay.closePopup($challengePopup);
	}
}

function _doAjax(data, url) {
	$.ajax({
		url,
		type: "POST",
		dataType: "json",
		data,
	})
		.done((response) => {
			_handleResponse(response);
		})
		.fail((error) => {
			console.error("error:", error);
		});
}

function _handleRedirectShopper(response) {
	if (response.redirectMethod === "POST") {
		$creditCardRedirectForm = $("#redirectForm");
		$creditCardRedirectForm.attr("method", "POST");
		$creditCardRedirectForm.attr("action", response.redirectUrl);
		const redirectData = response.redirectData;
		const dataKeys = Object.keys(redirectData);
		dataKeys.forEach((dataKey) => {
			const dataValue = redirectData[dataKey];
			$('<input type="hidden">')
				.attr({
					name: dataKey,
					value: dataValue,
				})
				.appendTo($creditCardRedirectForm);
		});
		$creditCardRedirectForm.submit();
	} else {
		window.location.href = response.redirectUrl;
	}
}

function _handleRefusedSepaAccount() {
	popupOverlay.openPopup($sepaPopup, { blur: true });
	_addCloseEventOnErrorMessagePopUp($sepaPopup);
}

function _handleRefusedAdyenPayment(refusalReason) {
	const $messageDiv = $checkoutPopup.find("#js-payment-error-messages__message");
	$messageDiv.html(`<p>${refusalReason}</p>`);
	popupOverlay.openPopup($checkoutPopup, { blur: true });
	_addCloseEventOnErrorMessagePopUp($checkoutPopup);
}

function _addCloseEventOnErrorMessagePopUp($popupMessagesDiv) {
	if ($popupMessagesDiv.length) {
		$(".js-ocm-popup-message-close, .js-ocm-popup-messages-layer_close").on("click", () => {
			popupOverlay.closePopup($popupMessagesDiv);
		});
	}
}

function _toggleSubmitButton() {
	$checkout = $(".js-checkout");
	const $inputs = $checkout.find("input");

	$inputs.keyup(function () {
		const $this = $(this);
		const $relevantInputs = $this.closest(".js-checkout").find("input");

		const $emptyInputs = $relevantInputs.filter(() => $.trim(this.value) === "");
		const $submitButton = $this.closest(".js-checkout").find("button[type='submit']");
		if (!$emptyInputs.length) {
			if ($submitButton.hasClass("c-btn--abort")) {
				$submitButton.removeClass("c-btn--abort");
			}
			$submitButton.addClass("c-btn--brand");
		} else {
			if ($submitButton.hasClass("c-btn--brand")) {
				$submitButton.removeClass("c-btn--brand");
			}
			$submitButton.addClass("c-btn--abort");
		}
	});
}

function _debitValidation() {
	$debitForm = $("#debit-form");
	$iban = $("#IBAN");
	if ($debitForm.length) {
		$iban.mask("AA 00 0000 0000 0000 0000 00");
		_toUpper($iban);
		$debitForm.attr("novalidate", "novalidate");
		$debitForm.on(
			"submit",
			null,
			{ callback: submitForm, errorCallback: pushSubmitDataLayer },
			formValidate.validateFormOnSubmit
		);
		$debitForm.on(
			"change",
			"input, select",
			{ errorCallback: pushChangeDataLayer },
			formValidate.validateElementOnChange
		);
	}
}

function _invoiceValidation() {
	const $invoiceForm = $("#invoice-form");
	if ($invoiceForm.length) {
		$invoiceForm.attr("novalidate", "novalidate");
		$invoiceForm.on("submit", null, { callback: submitForm, errorCallback: null }, formValidate.validateFormOnSubmit);
		$invoiceForm.on("change", "input", { errorCallback: null }, formValidate.validateElementOnChange);
	}
}

function _toUpper(value) {
	value.on("change", function () {
		// store current positions in variables
		const start = this.selectionStart;
		const end = this.selectionEnd;

		this.value = this.value.toUpperCase();

		// restore from variables...
		this.setSelectionRange(start, end);
	});
}

function _creditCardValidation() {
	$creditCardForm = $("#credit-card");
	if ($creditCardForm.length) {
		$creditCardForm.attr("novalidate", "novalidate");
		$creditCardForm.on("submit", null, { callback: submitForm }, formValidate.validateFormOnSubmit);
	}
}

// Formulare für bestehende Kreditkarten aktivieren
function _creditCardDataValidation() {
	$creditCardDataForm = $("[id^=credit-card-data]");

	$creditCardDataForm.each(function () {
		if ($(this).length) {
			$(this).attr("novalidate", "novalidate");
			$(this).on("submit", null, { callback: submitForm }, formValidate.validateFormOnSubmit);
		}
	});
}

const _creditCardDataRemove = function () {
	const creditCardData = ".js-credit-card-data";
	const removeButton = ".js-credit-card-remove";

	$("body").on("click", removeButton, function () {
		const $this = $(this);
		const ref = $this.attr("data");
		const url = $this.attr("data-url");

		$.get(url, { ref }, (data) => {
			console.log(data);
		});

		$this.closest(creditCardData).remove();
		if (!$(".js-credit-card-data").length) {
			$(".js-credit-card-data-wrapper").remove();
		}
	});
};

function _debitDataRemove() {
	debitData = ".js-debit-data";
	$debitRemove = $(".js-debit-remove");
	preview = ".c-checkout-header__preview";
	$paymentInfo = $(".js-checkout--payment");
	$debitRemove.each(function () {
		const $this = $(this);
		$this.on("click", () => {
			const CSRFToken = $("form").find("input[name='CSRFToken']").val();
			const code = $this.closest(debitData).attr("data-id");
			const url = $this.attr("data-delete-url");
			$this.closest(debitData).remove();
			if (!$(".js-debit-data").length) {
				$(".js-debit-data-wrapper").remove();
			}

			$paymentInfo.find(preview).filter(`[data-id=${code}]`).remove();

			$.ajax({
				type: "POST",
				url,
				data: { CSRFToken, paymentInfoCode: code },
			})
				.done((response) => {
					console.log(response);
				})
				.fail((error) => {
					console.log(error);
				});
		});
	});
}

function _fillInvoicePrivacyPolicyLink() {
	const linkParam = $("#commonInvoicePrivacyPolicyLink");
	if (linkParam.length > 0) {
		const linkUrl = linkParam.attr("data-linkUrl");
		$(".js-invoicePrivacyPolicy-btn").each(function () {
			$(this).attr("href", linkUrl);
		});
	}
}

const _pushPaymentMethodToDataLayer = () => {
	$("body").on("click", ".js-choose-payment", function () {
		const paymentMethod = $(this).attr("data-payment-method");
		const dataLayerCheckoutOption = {
			event: "checkoutOption",
			ecommerce: {
				...getFavoriteBrandsToggleDimension(),
				checkout_option: {
					actionField: { step: 4, option: paymentMethod },
				},
			},
		};
		pushDataLayer(dataLayerCheckoutOption);
		console.log("Triggered dataLayer push of event with paymentMethod: ", paymentMethod);
	});
};

const _trackChoosePaypalPayLater = () => {
	$("body").on("click", ".js-choose-paypal-paylater", () => {
		pushDataLayer({
			event: "GAevent",
			event_category: "checkout",
			event_action: "paypal_paylater_button",
		});
	});
};

const pushSubmitDataLayer = (message, elementID) => {
	pushDataLayer({
		event: "GAevent",
		event_category: "error_msg_submit",
		event_action: elementID,
		event_label: message,
	});
};

const pushChangeDataLayer = (message, elementID) => {
	pushDataLayer({
		event: "GAevent",
		event_category: "error_msg_change",
		event_action: elementID,
		event_label: message,
	});
};

export { init };
